import { ElementRef } from '@angular/core';
var AchooStoryPreviewComponent = /** @class */ (function () {
    function AchooStoryPreviewComponent() {
    }
    AchooStoryPreviewComponent.prototype.ngOnInit = function () {
    };
    AchooStoryPreviewComponent.prototype.toggleVideoPlayer = function () {
        if (!this.videoMedia) {
            return;
        }
        var method = this.videoMedia.nativeElement.paused ? 'play' : 'pause';
        this.videoMedia.nativeElement[method]();
    };
    AchooStoryPreviewComponent.prototype.afterEndVideo = function () {
        if (!this.videoMedia) {
            return;
        }
        this.videoMedia.nativeElement.parentElement.classList.remove('playing');
    };
    Object.defineProperty(AchooStoryPreviewComponent.prototype, "isPlaying", {
        get: function () {
            if (!this.videoMedia) {
                return false;
            }
            return !this.videoMedia.nativeElement.paused;
        },
        enumerable: true,
        configurable: true
    });
    return AchooStoryPreviewComponent;
}());
export { AchooStoryPreviewComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-story-preview/achoo-story-preview.component.ts.pre-build-optimizer.js